export function hasChanges(builder) {
  return !!builder.lastChanged
}

export function hasRootNode(builder) {
  return !!(builder && builder.rootId)
}
